





















import { Component, Prop, Vue } from 'vue-property-decorator'
import { TemplateCategoryInterface, TWMTemplatesInterface } from '@/pages/TWMCustomTemplates/types/twm-templates'
import TemplateCategory from '@/pages/TWMCustomTemplates/TemplateCategory.vue'

@Component({
    components: {
        TemplateCategory
    }
})
export default class TWMTemplates extends Vue {
    @Prop() value!: TWMTemplatesInterface
    addingNewCategory = false
    categoryName = ''

    get templateCategories(): TemplateCategoryInterface[] {
        return this.value.templates
    }

    addCategory() {
        if (this.categoryName) {
            this.value.templates.push({
                name: this.categoryName,
                display: true,
                type: 'default',
                list: []
            })
            this.categoryName = ''
            this.addingNewCategory = false
        }
    }

    deleteCategory(category: TemplateCategoryInterface) {
        this.value.templates.splice(this.value.templates.indexOf(category), 1)
    }
}
